export default {
  // graphqlEndpoint:
  //   "https://xscwbd2u4zgajbukw3fbwpntx4.appsync-api.us-east-1.amazonaws.com/graphql",
  graphqlEndpoint:
    process.env.NODE_ENV === "production"
      ? "https://xscwbd2u4zgajbukw3fbwpntx4.appsync-api.us-east-1.amazonaws.com/graphql"
      : "https://kp7uw6olrvfz5i6j6vjzbmbkvu.appsync-api.us-east-1.amazonaws.com/graphql",
  region: "us-east-1",
  authenticationType: "AWS_IAM"
  // authenticationType: "AMAZON_COGNITO_USER_POOLS",
  // apiKey: "da2-m3leglvft5fe3dtow4yjkht5ju"
};



// WEBPACK FOOTER //
// ./src/AppSync.js